/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2024
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["client/template", "component!base", "underscore"], function (Template, BaseView, _) {

  var GridLayoutTemplate = Template.extend({
    schema: new Template.Schema({
      inputAttributes: {
        cols: {
          type: "int",
          title: "editor_gridlayout_cols",
          values: [1, 2, 3, 4, 6, 12],
          defaultValue: 2,
        }
      }
    }),

    initialize: function () {
      Template.prototype.initialize.apply(this, _.toArray(arguments));
    },


    /** create the view accoring to the constructor of this.view */
    createView: function (options) {
      var ViewConstructor = options.ViewConstructor || this.constructor.View;
      var model = this.model(options);
      var options = this.getOptions(options);
      var that = this;
      var childViewConstructors
        = options.node
          ? _.map(options.node.children, function (childNode) {
            return function () {
              return that.createSubView(childNode, options, model);
            };
          })
          : null;

      var viewOptions = _.extend(
        {},
        this.attributeModel.get(),
        options,
        {
          model: model,
          el: this.el,
          template: this,
          childViewConstructors: childViewConstructors
        }
      );


      if (options.forceCreateNewElement && viewOptions.el == this.el) {
        // if viewOptions.el (retrieved by this.createEl()) is the template el (default) rather than a 
        // newly created element, delete it from the options and let the Backbone.View create the element
        // https://backbonejs.org/#View-el
        delete viewOptions.el;
      }

      var view = new ViewConstructor(viewOptions);
      this.instances.push(view);
      return view;
    },

    /*
    createSubView: function (childNode, options, model) {
      return childNode.template.createView({
        application: options.application,
        model: model,
        node: childNode,
        el: template.el
      });
    },
      */
  });

  GridLayoutTemplate.View = BaseView.extend({
    initialize: function (options) {
      // make it now more or less static
      this.childViewConstructors = options.childViewConstructors;
      this.childViews = [];
      this.render();
    },

    remove: function () {
      return BaseView.prototype.remove.apply(this, arguments);
    },

    render: function () {
      if (this.childViews.length) {
        return this;
      }

      var eltCount= this.childViewConstructors.length;
      var colCount = this.options.cols || 2;
      colCount = _.isString(colCount) ? Number.parseInt(colCount) : colCount;
      var rowCount = Math.trunc(eltCount / colCount) + (eltCount % colCount > 0) ;

      var spanNum = Math.max(1, 12 / colCount);
      var spanClass = "span" + spanNum.toString();
      
      for (var i = 0; i < rowCount; i++) {
        var row = this.make("div", {"class": "row-fluid", "data-generated": "true"});
        
        for (var j = 0; j < colCount; j++) {
          var offset = i * colCount + j;
          if (offset >= eltCount) {
            break;
          }
          var col = this.make("div", {"class": spanClass, "data-generated": "true"});
          var childViewConstructor = this.childViewConstructors[offset];
          // TODO move the template before calling constructor
          var childView = childViewConstructor();
          this.childViews.push(childView);
          col.appendChild(childView.el);
          row.appendChild(col);
        }

        this.el.appendChild(row);
      }
      return this;

    }
  });

  return GridLayoutTemplate;
});
